// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"53498c41","455":"f4e68d52","821":"93dbd7b9","977":"f485aa88"}[chunkId] + ".chunk.js";
};